export default {
  recent7: 'Past 7 days',
  recent30: 'Past 30 days',
  recent1y: 'Past year',
  recent5y: 'Past 5 years'
}